import { BOLLO_IMPORTO, BOLLO_SOGLIA, BOLLO_ACCORPAMENTO_SOGLIA, SCADENZE_BOLLO } from '../constants/bollo';

export function calcolaBolloTrimestre(fatture, trimestre, anno) {
  const config = SCADENZE_BOLLO.find(s => s.trimestre === trimestre);
  if (!config) return null;

  const fattureTrimestreConBollo = fatture.filter(f => {
    const dataFattura = new Date(f.issueDate);
    const meseFattura = dataFattura.getMonth() + 1;
    const annoFattura = dataFattura.getFullYear();
    return annoFattura === anno &&
           config.mesi.includes(meseFattura) &&
           f.grossAmount > BOLLO_SOGLIA;
  });

  const importoDovuto = fattureTrimestreConBollo.length * BOLLO_IMPORTO;

  // Calcola data scadenza
  const annoScadenza = config.scadenza.annoSuccessivo ? anno + 1 : anno;
  const dataScadenza = new Date(annoScadenza, config.scadenza.mese - 1, config.scadenza.giorno);

  return {
    trimestre,
    label: config.label,
    numeroFatture: fattureTrimestreConBollo.length,
    importoDovuto,
    dataScadenza,
    puoAccorpare: importoDovuto < BOLLO_ACCORPAMENTO_SOGLIA,
    fatture: fattureTrimestreConBollo
  };
}

export function calcolaBolloAnnuale(fatture, anno) {
  const trimestri = ['Q1', 'Q2', 'Q3', 'Q4'].map(t => calcolaBolloTrimestre(fatture, t, anno));
  const totale = trimestri.reduce((sum, t) => sum + t.importoDovuto, 0);

  // Trova prossima scadenza
  const oggi = new Date();
  const prossima = trimestri.find(t => t.dataScadenza > oggi && t.importoDovuto > 0);

  return {
    trimestri,
    totaleAnnuo: totale,
    totaleFatture: trimestri.reduce((sum, t) => sum + t.numeroFatture, 0),
    prossimaScadenza: prossima
  };
}
